// extracted by mini-css-extract-plugin
module.exports = {"shareButtons":"l_6"};